// @owners { team: patients }
import { SPACING } from '@alto/design-library-tokens';
import {
  Body,
  Button,
  Card,
  Column,
  H1,
  Icon,
  Illustration,
  LgPadding,
  MdSpacing,
  PresentationListItem,
  XsSpacing,
} from '@alto/design-system';
import { useNavigation } from '@alto/navigation';
import React from 'react';
import { usePageViewedEvent } from '~shared/hooks';
import { EVENTS } from '~shared/lib/analytics/src/constants';
import { getProgynyWizardFirstFill } from '~shared/selectors/checkout/progyny';
import { useSelectorShared } from '~shared/store';
import { ProgynyPage } from '../../shared/components/ProgynyPage';
import { progynyAssets } from '../../shared/components/progynyAssets';
import { getProgynyWizardNextRoute } from '../helpers/getProgynyWizardNextRoute';

export const ProgynyWizardIntro3 = () => {
  const { getCurrentRouteName, goBack, navigate } = useNavigation();
  const firstFill = useSelectorShared(getProgynyWizardFirstFill);
  const isRefill = !firstFill;

  const onNext = () => {
    const currentRoute = getCurrentRouteName();
    const nextRouteName = getProgynyWizardNextRoute(currentRoute, firstFill);
    if (!nextRouteName) return;
    navigate(nextRouteName);
  };

  usePageViewedEvent({
    event: EVENTS.PROGYNY_INTRO_3_VIEWED,
    params: {
      is_refill: isRefill,
    },
  });

  return (
    <ProgynyPage
      dismissIcon="chevronleft"
      onDismiss={goBack}
      HeaderContent={
        <LgPadding>
          <Column center>
            <Illustration
              objectFit="contain"
              resizeMode="contain"
              size="lg"
              source={progynyAssets.rx}
            />
            <XsSpacing />
            <H1
              testID="e2e-progyny-step3-header"
              center
            >
              What you'll need to complete your order
            </H1>
          </Column>
        </LgPadding>
      }
      buttons={[
        <Button
          key="Continue"
          onPress={onNext}
          testID="e2e-progyny-step3-button"
        >
          Get started now
        </Button>,
      ]}
    >
      <Card>
        <MdSpacing />
        <PresentationListItem
          LeftContent={<Icon name="checkcircle" />}
          text="Your treatment calendar and prescriptions, including current dosage information"
        />
        <PresentationListItem
          LeftContent={<Icon name="checkcircle" />}
          text="The amount of each medication you have on hand (if you have any from a previous cycle)"
        />
        <LgPadding topPadding={SPACING.STATIC.SM}>
          <Body>
            It should take about <Body fontFamily="semibold">5-10 minutes</Body> to get your order in. Alto will be with
            you through every step.
          </Body>
        </LgPadding>
      </Card>
    </ProgynyPage>
  );
};
